<style lang="scss" scoped>
  * {
  }
</style>

<template>
  <div v-if="state == 1 || state == 3 || state == 4 || state == 5" style="display:inline-block;">
    <el-button icon="el-icon-printer" type="primary" @click="dayins()"
      >打印
    </el-button>
    <!-- 打印条件弹出框 -->
    <el-dialog
		:title="dayin.title"
		:visible.sync="dayin.dialogFormVisible"
		:show-close="true"
		:close-on-click-modal="false"
		append-to-body
		width="30%"
    >
      <div v-show="dayin.Status == 1">
        <el-form ref="Excform" :model="dayin.date" label-width="80px">
          <template>
            <el-checkbox
              :indeterminate="isIndeterminates"
              v-model="checkAlls"
              @change="handleCheckAllChanges"
              >全选
            </el-checkbox>
            <div style="margin: 10px 0"></div>
            <el-checkbox-group
              v-model="checkedOptionss"
              @change="handleCheckedCitiesChanges"
            >
              <el-checkbox
                v-for="(value, index) in AllOptionss"
                :label="value"
                :key="index"
                v-show="value.name&&value.name!=='操作' ? true : false"
                style="width: 180px; height: 40px"
              >
                {{ value.name }}
              </el-checkbox>
            </el-checkbox-group>
          </template>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button type="primary" @click="CreateOneFormPage"
            >{{ $t('table.confirm') }}
          </el-button>
        </div>
      </div>
    </el-dialog>
  </div>
  <div v-else-if="state == 2" style="display:inline-block;">
    <el-button icon="el-icon-printer" type="primary" @click="dayinImg()"
      >打印
    </el-button>
  </div>
</template>

<script>
let optionss = []
export default {
	components: {},
	beforeRouteEnter (to, from, next) {
		next()
	},
	props: {
		size: {
			type: Number,
			default: 10
		},
		// 统计时间范围 根据表单里面的查询时间
		orderTime: {
			old: '',
			new: ''
		},
		// 表名
		name: {
			info: ''
		},
		// 1 时，打印表单 ； 2 时，打印图片; 3 时，打印入库单(包含总金额、总数量)，根据 1 兼容的; 4 时，打印出库单(包含总金额、总数量)，根据 3 兼容的;  5时，打印采购单、盘点单
		state: {
			type: Number,
			default: 1
		},
		// 仓库名
		dayinName: {
			type: String,
			default: '1'
		},
		// 出入库单
		sums: {
			type: Array,
			required: false
		},
		numsums: {
			type: Array,
			required: false
		},
		// 图片百分比
		baifenbi: {
			type: Number,
			default: 50
		},
		// 入库总数量
		totalNum: {
			type: Number,
			default: 0
		},
		// 入库总金额
		totalAmount: {
			type: Number,
			default: 0
		},
		// 图片地址数组
		ArrImg: {
			type: Array,
			required: false
		},
		filterLabel: {
			type: Array,
			default: () => []
		}
	},
	computed: {},
	data () {
		return {
			times: '',
			dayin: {
				dialogFormVisible: false,
				dialogStatus: '',
				Status: 1,
				title: '选择打印内容',
				zhibiaoren: '',
				date: {}
			},

			// 打印多选框
			checkAlls: false,
			checkedOptionss: [],
			AllOptionss: [],
			isIndeterminates: true,
			aaa: []
		}
	},
	mounted () {},
	methods: {
		// 格式一 图片打印
		async dayinImg () {
			// console.log(this.state, this.ArrImg);
			// let arr = []
			// await this.tableData.forEach(val => {
			//   arr.push(val.universalUrl)
			// })
			// console.log(this.tableData,arr,"a")
			// 表名
			const biaoming = this.name.info ? this.name.info : '汇总表'
			// // 打印样式
			const style =
          '@page {  } ' +
          '@media print {html,body{margin:0;padding:0;overflow: hidden;} '

			printJS({
				printable: this.ArrImg,
				type: 'image',
				header: biaoming,
				headerStyle: '',
				style,
				imageStyle: 'width:20%;margin-bottom:10px;float:left;'
			})
		},
		// 格式 二 表格打印
		handleCheckAllChanges (val) {
			// console.log(val, optionss);
			this.checkedOptionss = val ? optionss : []
			this.isIndeterminates = false
			// 遍历出数字，用于辨别选中的哪一列
			// let arr = [];
			// for (let a = 0; a < this.checkedOptionss.length; a++) {
			//   arr.push(this.checkedOptionss[a].sum);
			// }
			// this.dysum = arr;
			// console.log(this.dysum);
			// console.log("quan", this.checkedOptionss);
		},
		handleCheckedCitiesChanges (value) {
			// console.log(value);
			const checkedCount = value.length
			this.checkAlls = checkedCount === this.AllOptionss.length
			this.isIndeterminates =
          checkedCount > 0 && checkedCount < this.AllOptionss.length
			this.checkedOptionss.sort((a, b) => a.index - b.index)
			// console.log(this.checkedOptionss);
			localStorage.setItem(
				'checkedOptionss',
				JSON.stringify(this.checkedOptionss)
			)
			// 遍历出数字，用于辨别选中的哪一列
			// let arr = [];
			// for (let a = 0; a < this.checkedOptionss.length; a++) {
			//   arr.push(this.checkedOptionss[a].sum);
			// }
			// this.dysum = arr;
			// console.log(this.dysum);
		},
		dayins (row, state) {
			// console.log(654, this.orderTime, this.name.info);
			// if (!this.AllOptionss.length) {
			optionss = []
			const html = document.querySelector('#printJSform').innerHTML
			// 新建一个 DOM
			const div = document.createElement('div')
			div.innerHTML = html
			// // 删除多余的表头
			div.querySelector('th.gutter').remove()
			// 提取第一个表格的内容 即表头
			const tht = div.querySelectorAll('.el-table__header-wrapper th')

			// console.log(tht, thtaa, "提取表头");
			for (let i = 0; i < tht.length; i++) {
				optionss.push({
					name: tht[i].innerText,
					index: i
				})
			}
			const filterOptions = optionss.filter(item => !this.filterLabel.includes(item.name))
			this.checkedOptionss = filterOptions
			this.AllOptionss = filterOptions
			div.remove()
			// }
			// console.log(this.AllOptionss, "表头neirong");
			this.dayin.dialogFormVisible = true
			this.dayin.date = Object.assign({}, row)
			this.dayin.dialogStatus = state
			// console.log(this.dayin.date,55555);
		},
		// 输入制表人
		xiayibu () {
			if (this.dayin.zhibiaoren) {
				this.dayin.Status = 2
				// this.aaa = localStorage.getItem("checkedOptionss");
				// this.checkedOptionss = this.aaa ? JSON.parse(this.aaa) : []
				// console.log('3333333333333', JSON.parse(this.aaa), this.checkedOptionss)
			} else {
				this.$message.error('制表人不能为空')
			}
		},
		// 打印
		CreateOneFormPage () {
			const arrs = []
			this.checkedOptionss.forEach((item) => {
				if (item.name !== '' && item.name !== '操作') {
					arrs.push(item)
				}
			})
			this.checkedOptionss = arrs
			console.log(this.checkedOptionss, 45)
			this.dayin.zhibiaoren = this.$store.state.user.name
			if (!this.checkedOptionss.length) {
				this.$message.error('请选择要打印的字段')
				return
			}

			this.dayin.dialogFormVisible = false
			// console.log(this.checkedOptionss);
			const html = document.querySelector('#printJSform').innerHTML
			// console.log("html: " + html);
			// console.log("传输state", this.state);
			let htmls
			if (this.state == 3 || this.state == 4 || this.state == 5) {
				// let tht = div.querySelectorAll(".mc-table td");
				// console.log(tht)
				htmls = '<table class="mc-table" id="printRk" border  style="text-align: center; border-spacing: 0px;word-break:break-all" width="100%">'
				htmls += document.querySelector('#printRk').innerHTML
				htmls += '</table>'
				// console.log(htmls);
			}

			// 新建一个 DOM
			const div = document.createElement('div')
			const printDOMID = 'printDOMElement'
			div.id = printDOMID
			div.innerHTML = html
			// 排除fixed列
			if (div.querySelector('.el-table__fixed')) div.querySelector('.el-table__fixed').remove()
			if (div.querySelector('.el-table__fixed-right')) div.querySelector('.el-table__fixed-right').remove()
			if (div.querySelector('.el-table__fixed-right-patch')) div.querySelector('.el-table__fixed-right-patch').remove()
			// // 删除多余的表头
			div.querySelector('th.gutter').remove()
			// console.log(div);
			// 提取第一个表格的内容 即表头
			const tht = div.querySelectorAll('.el-table__header-wrapper th')
			const ThtTextArry = []
			for (let i = 0, len = this.checkedOptionss.length; i < len; i++) {
				if (tht[this.checkedOptionss[i].index].innerText !== '') { ThtTextArry.push(tht[this.checkedOptionss[i].index].innerText) }
			}

			// 获取表格主体数据
			const ths = div.querySelectorAll('.el-table__body td')
			// console.log(ths, "主体");
			const ThsTextArry = []
			// console.log(this.size, this.checkedOptionss, ths, tht);
			for (let a = 0; a < this.size; a++) {
				ThsTextArry[a] = []
				for (let i = 0, len = this.checkedOptionss.length; i < len; i++) {
					// if (
					//   ths[tht.length * a + this.checkedOptionss[i].index].innerText !== ""
					// )
					ThsTextArry[a].push(
						ths[tht.length * a + this.checkedOptionss[i].index].innerText
					)
				}
			}
			// 提取尾部表格的内容
			const thd = div.querySelectorAll('.el-table__footer-wrapper td')
			// console.log(thd);

			const ThdTextArry = []
			if (thd.length) {
				for (let i = 0, len = this.checkedOptionss.length; i < len; i++) {
					// for (let i = 0, len = thd.length; i < len; i++) {
					// 2020-10-27
					ThdTextArry.push(thd[this.checkedOptionss[i].index].innerText)
					// if (thd[i].innerText !== "") ThdTextArry.push(thd[i].innerText);
				}

				div.querySelector('.el-table__footer-wrapper').remove()
			}

			// for (let i = 0, len = thd.length; i < len; i++) {
			//   if (thd[i].innerText !== "") ThdTextArry.push(thd[i].innerText);
			// }
			// div.querySelector('.hidden-columns').remove()
			// // 第一个表格的内容提取出来后已经没用了 删掉
			div.querySelector('.el-table__body').remove()

			// // 将第一个表格的内容插入到第二个表格
			let newHTML = ''
			// 头部
			// newHTML += "<tr>";
			// for (let i = 0, len = ThtTextArry.length; i < len; i++) {
			//   newHTML +=
			//     '<td style="text-align: center; font-weight: bold">' +
			//     ThtTextArry[i] +
			//     "</td>";
			// }
			// newHTML += "</tr>";
			// 内容
			// console.log(ThtTextArry);
			for (let a = 0, len = this.size; a < len; a++) {
				newHTML += '<tr>'
				for (let i = 0, len = ThtTextArry.length; i < len; i++) {
					newHTML +=
              '<td style="text-align: center;">' + ThsTextArry[a][i] + '</td>'
				}
				newHTML += '</tr>'
				// div.querySelector('.el-table__body-wrapper table').insertAdjacentHTML('beforeEnd', footerHTML)
			}
			// 尾部
			// console.log(9897989);

			if (ThdTextArry.length) {
				// let num = 0;
				// let footer = [];
				// for (let i = 0, len = tht.length; i < len; i++) {
				//   if (i < 1 || i > 3) {
				//     footer.push(ThdTextArry[num]);
				//     num++;
				//   } else {
				//     footer.push(" ");
				//   }
				// }

				newHTML += '<tr>'
				for (let i = 0, len = ThdTextArry.length; i < len; i++) {
					// console.log(this.checkedOptionss[i].index);
					newHTML +=
              '<td style="text-align: center; color: red;">' +
              ThdTextArry[i] +
              '</td>'
				}
				newHTML += '</tr>'
				// let a = 0;
				// newHTML += "<tr>";
				// for (let i = 0, len = ThtTextArry.length; i < len; i++) {
				//   if (i < 1 || i > 3) {
				//     newHTML +=
				//       '<td style="text-align: center; color: red;">' +
				//       ThdTextArry[a] +
				//       "</td>";
				//     a++;
				//   } else {
				//     newHTML +=
				//       '<td style="text-align: center; font-weight: bold">' +
				//       " " +
				//       "</td>";
				//   }
				// }

				// newHTML += "</tr>";
			}

			// console.log(8989)
			// console.log(12334,this.orderTime[0])
			// console.log(newHTML, div);
			// div.querySelector('.el-table__body-wrapper table').insertAdjacentHTML('afterbegin', newHTML)
			let elements = div.querySelectorAll(
				'.el-table__header-wrapper table colgroup col'
			)
			// console.log(elements, 654);
			const arr = this.AllOptionss.filter((v) => {
				return (
					this.checkedOptionss.findIndex((v2) => {
						return v2.index == v.index
					}) < 0
				)
			})
			for (let i = 0, len = arr.length; i < len; i++) {
				elements[arr[i].index].remove()
			}
			elements = div.querySelectorAll(
				'.el-table__header-wrapper table thead tr th'
			)
			for (let i = 0, len = arr.length; i < len; i++) {
				elements[arr[i].index].remove()
			}

			// 制表人，查询时间，审核人、制表时间
			// await this.zhibiaoTime()
			let times = new Date().getFullYear() + '-'
			// console.log("打印时间", new Date().getMonth() - 0 + 1);
			if (new Date().getMonth() - 0 + 1 < 10) {
				// 获取系统月
				times += '0' + (new Date().getMonth() - 0 + 1) + '-'
				// console.log(times, 987);
			} else {
				times += new Date().getMonth() - 0 + 1 + '-'
			}
			if (new Date().getDate() < 10) {
				// 获取系统天
				times += '0' + new Date().getDate() + '  '
			} else {
				times += new Date().getDate() + '  '
			}
			if (new Date().getHours() < 10) {
				// 获取系统时，
				times += '0' + new Date().getHours() + ':'
			} else {
				times += new Date().getHours() + ':'
			}
			if (new Date().getMinutes() < 10) {
				// 获取系统分，
				times += '0' + new Date().getMinutes() + ':'
			} else {
				times += new Date().getMinutes() + ':'
			}
			if (new Date().getSeconds() < 10) {
				// 获取系统秒，
				times += '0' + new Date().getSeconds()
			} else {
				times += new Date().getSeconds()
			}
			// footerHTML += '</tr>'
			div.querySelector('.hidden-columns').remove()
			// div.querySelector("colgroup").remove();
			// 查询时间（头部）
			// 右侧
			// let cxsh = `<div style="width:100%;font-size: 20px;overflow: hidden;"><span style="display: inline-block; float: right; padding: 0 0 10px 0;margin: 0 0 0 20px;">统计时间:${this.orderTime.old} 至 ${this.orderTime.new}</span></div>`;
			// 左侧
			let cxsh
			// 没有统计时间
			if (this.orderTime) {
				cxsh = `<div style="width:100%;font-size: 20px;overflow: hidden;text-align:center;"><span style="display: inline-block; padding: 0 0 10px 0;margin: 0 0 0 20px;">统计时间:${this.orderTime.old} 至 ${this.orderTime.new}</span></div>`
			}
			// 制表人、审核人、制表时间（尾部）
			// 右侧
			// let abc = `<div style="width:100%;overflow: hidden;font-size: 20px;text-align: right;">`;
			// 左侧
			let abc = '<div style="width:100%;overflow: hidden;font-size: 20px;text-align: left;">'
			abc += '<span style="display: inline-block;  padding:10px 0 0 0;margin: 0 0 0 20px;">制表人:_____________</span>'
			abc += '<span style="display: inline-block;  padding:10px 0 0 0;margin: 0 0 0 20px;">审核人:______________</span>'
			abc += `<span style="display: inline-block;  padding:10px 0 0 0;margin: 0 0 0 20px;">制表日期:${times}</span></div>`
			// console.log(1233,this.orderTime[0])
			document.querySelector('.el-table__header-wrapper table').style.width =
          '100%'
			// 没有统计时间
			if (this.orderTime) {
				div
					.querySelector('.el-table__header-wrapper table')
					.insertAdjacentHTML('beforeBegin', cxsh)
			}
			if (this.state == 3) {
				div
					.querySelector('.el-table__header-wrapper')
					.insertAdjacentHTML('beforeBegin', htmls)
				newHTML +=
					`<tr style="text-align: right; border-color: red; color: red;"><td>总金额</td><td colspan="${ThtTextArry.length - 1}">${this.totalAmount}</td></tr>` +
					`<tr style="text-align: right; border-color: red; color: red;"><td>总数量</td><td colspan="${ThtTextArry.length - 1}">${this.totalNum}</td></tr>`
			}
			if (this.state == 4) {
				div
					.querySelector('.el-table__header-wrapper')
					.insertAdjacentHTML('beforeBegin', htmls)
				newHTML +=
					`<tr style="text-align: right; border-color: red; color: red;"><td>总金额</td><td colspan="${ThtTextArry.length - 1}">${Number(this.sums[10].toFixed(2) / 100)}</td></tr>` +
					`<tr style="text-align: right; border-color: red; color: red;"><td>总数量</td><td colspan="${ThtTextArry.length - 1}">${Math.round(parseFloat(this.numsums[7]) * 100) / 100
					}</td></tr>`
			}
			if (this.state == 5) {
				div
					.querySelector('.el-table__header-wrapper')
					.insertAdjacentHTML('beforeBegin', htmls)
			}
			div
				.querySelector('.el-table__header-wrapper table')
				.insertAdjacentHTML('beforeEnd', newHTML)
			div
				.querySelector('.el-table__header-wrapper table')
				.insertAdjacentHTML('afterEnd', abc)

			// div.querySelector('.el-table__header-wrapper table').insertAdjacentHTML('beforeEnd', footerHTML)
			// console.log(div);
			// 打印样式
			const style =
          '@page {  } ' +
          `@media print {html,body{margin:0;padding:0;overflow: hidden;height} table{height: auto;padding:0;margin:0 auto;}
            table tr td,th { border-collapse: collapse;padding: 15px;border:1px #000 solid; text-align: center;word-break:break-all}
            .has-gutter tr th{} table{width:100% !important;}`

			// // 将新的 DIV 添加到页面 打印后再删掉
			div.querySelector('.el-table__body-wrapper').remove()
			document.querySelector('body').appendChild(div)
			// document.getElementsByClassName("app-main").appendChild(div);
			// console.log(ThsTextArry)
			// console.log(ThdTextArry)
			// console.log(div.innerHTML)
			// console.log(123)
			let biaoming
			if (this.state == 3 || this.state == 4) {
				biaoming = this.name.info
					? this.dayinName + this.name.info
					: '汇总表'
			} else {
				biaoming = this.name.info ? this.name.info : '汇总表'
			}

			printJS({
				printable: printDOMID,
				type: 'html',
				header: biaoming,
				headerStyle: 'text-align:center;',
				maxWidth: '100%',
				// targetStyles: ['border', 'padding: 15px'],
				scanStyles: false,
				style
				// "table tr td,th { border-collapse: collapse;padding: 15px;border:1px #000 solid; text-align: center;}", // 表格样式
			})
			// document.getElementsByClassName("app-container")[0].appendChild(div);
			div.remove()
			// this.checkedOptionss = [];
			this.dayin.Status = 1
		}
	}
}
</script>
